type ContentEditorExitHandler = () => Promise<boolean>;

type ContentEditorExitRegistration = {
  handler: ContentEditorExitHandler;
  inFlightRequest: Promise<boolean> | null;
};

let activeContentEditorExitRegistration: ContentEditorExitRegistration | null =
  null;

export function registerContentEditorExitHandler(
  handler: ContentEditorExitHandler
) {
  const registration: ContentEditorExitRegistration = {
    handler,
    inFlightRequest: null,
  };
  activeContentEditorExitRegistration = registration;

  return () => {
    if (activeContentEditorExitRegistration === registration) {
      activeContentEditorExitRegistration = null;
    }
  };
}

export async function requestContentEditorExit() {
  const registration = activeContentEditorExitRegistration;
  if (!registration) {
    return true;
  }

  if (registration.inFlightRequest) {
    return registration.inFlightRequest;
  }

  const inFlightRequest = registration.handler().finally(() => {
    if (registration.inFlightRequest === inFlightRequest) {
      registration.inFlightRequest = null;
    }
  });
  registration.inFlightRequest = inFlightRequest;

  return inFlightRequest;
}
